<script lang="ts">
    import type {User} from 'typings/portaro.be.types';
    import {getLocalization} from 'core/svelte-context/context';

    export let user: User;

    const localize = getLocalization();
</script>

<span class="sr-only">{localize(/* @kp-localization ctenar.username */ 'ctenar.username')}:</span>

<code class="username"
      title={localize(/* @kp-localization ctenar.username */ 'ctenar.username')}>
    {user.username}
</code>